// SingleListingPageStyles.js





import theme from './../../theme';

export const styles = {
  container: { padding: "20px" },
  inputField: {
    marginBottom: "15px",
    width: "100%",
    padding: "10px",
    fontSize: "1rem",
    borderRadius: "5px",
    border: "1px solid #ccc",
    "&:focus": { borderColor: "#81c241", outline: "none" },
  },

  image: {
    width: '100%',
    maxHeight: '500px',
    objectFit: 'cover',
    borderRadius: '12px',
    boxShadow: theme.shadows.medium,
    marginBottom: '20px',
  },
  title: {
    fontFamily: theme.fonts.primary,
    fontSize: '2.5rem',
    fontWeight: '700',
    marginBottom: '10px',
    color: theme.colors.darkGray,
  },
  location: {
    fontFamily: theme.fonts.secondary,
    fontSize: '1.25rem',
    marginBottom: '10px',
    color: theme.colors.mediumGray,
  },
  price: {
    fontFamily: theme.fonts.primary,
    fontSize: '1.75rem',
    fontWeight: '700',
    marginBottom: '20px',
    color: theme.colors.green,
  },
  description: {
    fontFamily: theme.fonts.secondary,
    fontSize: '1.15rem',
    lineHeight: '1.8',
    marginBottom: '30px',
    color: theme.colors.darkGray,
  },
  formContainer: {
    marginTop: '40px',
    padding: '20px',
    backgroundColor: theme.colors.lightGray,
    borderRadius: '12px',
    boxShadow: theme.shadows.medium,
  },
  formTitle: {
    fontFamily: theme.fonts.secondary,
    fontSize: '1.5rem',
    fontWeight: '700',
    marginBottom: '20px',
    color: theme.colors.darkGray,
  },

  checkbox: {
    marginRight: '10px',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '15px',
    fontSize: '1rem',
    color: theme.colors.darkGray,
    fontFamily: theme.fonts.secondary,
  },
  textArea: {
    width: '100%',
    height: '80px',
    padding: '10px',
    fontSize: '1rem',
    borderRadius: '5px',
    border: `1px solid ${theme.colors.lightGray}`,
    backgroundColor: theme.colors.white,
    marginBottom: '15px',
  },
  submitButton: {
    padding: '12px 30px',
    fontSize: '1rem',
    backgroundColor: '#81c241', // Primary green
    color: theme.colors.white,
    border: 'none',
    borderRadius: '25px',
    cursor: 'pointer',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#6aa832', // Darker green on hover
      transform: 'scale(1.05)',
    },
  },
};